// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationId } from './Fermentation';
import { fractionTypeEnum8f45884b } from './FractionTypeEnum8f45884b';
import { dspScreeningId } from './DspScreening';
import { operatorId } from './Operator';
import { invLocationId } from './InvLocation';
import { z } from 'zod';
export const dspProcessingId = (z.number());
export const dspProcessing = z.object({
    id: dspProcessingId,
    created_at: z.date(),
    fermentation_id: fermentationId.nullable(),
    weight_g: z.string(),
    container_weight_g: z.string().nullable(),
    output_supernatant_weight_g: z.string().nullable(),
    output_supernatant_marked_depleted: z.boolean(),
    parent_fraction_type: fractionTypeEnum8f45884b,
    parent_id: dspProcessingId.nullable(),
    screening_id: dspScreeningId.nullable(),
    steps: z.unknown(),
    output_pellet_weight_g: z.string().nullable(),
    pellet_dry_matter_content_pct: z.string().nullable(),
    output_broth_weight_g: z.string().nullable(),
    output_powder_weight_g: z.string().nullable(),
    operator_id: operatorId.nullable(),
    output_supernatant_location_id: invLocationId.nullable(),
    output_pellet_location_id: invLocationId.nullable(),
    output_broth_location_id: invLocationId.nullable(),
    output_powder_location_id: invLocationId.nullable(),
});
export const dspProcessingInitializer = z.object({
    id: dspProcessingId.optional(),
    created_at: z.date().optional(),
    fermentation_id: fermentationId.optional().nullable(),
    weight_g: z.string().optional(),
    container_weight_g: z.string().optional().nullable(),
    output_supernatant_weight_g: z.string().optional().nullable(),
    output_supernatant_marked_depleted: z.boolean().optional(),
    parent_fraction_type: fractionTypeEnum8f45884b,
    parent_id: dspProcessingId.optional().nullable(),
    screening_id: dspScreeningId.optional().nullable(),
    steps: z.unknown().optional(),
    output_pellet_weight_g: z.string().optional().nullable(),
    pellet_dry_matter_content_pct: z.string().optional().nullable(),
    output_broth_weight_g: z.string().optional().nullable(),
    output_powder_weight_g: z.string().optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    output_supernatant_location_id: invLocationId.optional().nullable(),
    output_pellet_location_id: invLocationId.optional().nullable(),
    output_broth_location_id: invLocationId.optional().nullable(),
    output_powder_location_id: invLocationId.optional().nullable(),
});
export const dspProcessingMutator = z.object({
    id: dspProcessingId.optional(),
    created_at: z.date().optional(),
    fermentation_id: fermentationId.optional().nullable(),
    weight_g: z.string().optional(),
    container_weight_g: z.string().optional().nullable(),
    output_supernatant_weight_g: z.string().optional().nullable(),
    output_supernatant_marked_depleted: z.boolean().optional(),
    parent_fraction_type: fractionTypeEnum8f45884b.optional(),
    parent_id: dspProcessingId.optional().nullable(),
    screening_id: dspScreeningId.optional().nullable(),
    steps: z.unknown().optional(),
    output_pellet_weight_g: z.string().optional().nullable(),
    pellet_dry_matter_content_pct: z.string().optional().nullable(),
    output_broth_weight_g: z.string().optional().nullable(),
    output_powder_weight_g: z.string().optional().nullable(),
    operator_id: operatorId.optional().nullable(),
    output_supernatant_location_id: invLocationId.optional().nullable(),
    output_pellet_location_id: invLocationId.optional().nullable(),
    output_broth_location_id: invLocationId.optional().nullable(),
    output_powder_location_id: invLocationId.optional().nullable(),
});
//# sourceMappingURL=DspProcessing.js.map